import type { ItemResponse } from '@finn-no/mobility-item-insertion-shared';
import { Trans } from '@lingui/react/macro';
import { Button } from '@warp-ds/react';
import { useFormState } from 'react-hook-form';
import { getHuckConfig } from '../utils/getHuckConfig.js';
import { PreviewButton } from './preview-button.js';
import { TermsAndConditions } from './terms-and-conditions.js';

type Props = {
  onSubmit: () => void;
  onAbort: () => void;
  item: ItemResponse;
};

export const FormActions = ({ onSubmit, onAbort }: Props) => {
  const { isSubmitting } = useFormState();
  const config = getHuckConfig();
  const isEditMode = config.mode === 'edit';
  return (
    <>
      <PreviewButton className="mb-16" />
      <div className="flex gap-16 flex-wrap">
        <Button type="submit" primary loading={isSubmitting} className="flex-1 max-w-none" onClick={onSubmit}>
          {config.mode === 'create' ? (
            <Trans
              id="mobility-item-insertion.button.continue"
              comment="Button text for continuing to the next step in the form"
            >
              Continue
            </Trans>
          ) : (
            <Trans id="mobility-item-insertion.button.save" comment="Button text for saving changes to an existing ad">
              Save
            </Trans>
          )}
        </Button>
        {isEditMode ? (
          <Button
            secondary
            disabled={isSubmitting}
            loading={isSubmitting}
            className="flex-1 max-w-none"
            onClick={onAbort}
          >
            <Trans id="mobility-item-insertion.button.abort" comment="Button text for aborting the insertion form">
              Abort
            </Trans>
          </Button>
        ) : null}
      </div>
      <TermsAndConditions className="text-center mx-16 my-32" />
    </>
  );
};
